import { useCurrentBrandQuery } from '@/hooks/queries/use-current-brand-query';
import api from '@/libs/axiosInstance';
import { useQuery } from '@tanstack/react-query';

export interface BrandDnaData {
  brandDna: string | null;
  brandDnaSourceUrl: string | null;
  brandDnaUpdatedAt: string | null;
}

export const brandDnaQueryKey = (brandId: string) => ['brandDna', brandId] as const;

const fetchBrandDna = async (): Promise<BrandDnaData> => {
  const { data } = await api.get<{ data: BrandDnaData }>('/dashboard/brands/me/dna');
  return {
    brandDna: data.data.brandDna ?? null,
    brandDnaSourceUrl: data.data.brandDnaSourceUrl ?? null,
    brandDnaUpdatedAt: data.data.brandDnaUpdatedAt ?? null,
  };
};

export const useBrandDnaQuery = () => {
  const { data: brand } = useCurrentBrandQuery();
  const brandId = brand?.id ?? '';

  return useQuery<BrandDnaData, Error>({
    queryKey: brandDnaQueryKey(brandId),
    queryFn: fetchBrandDna,
    enabled: !!brandId,
  });
};
